import { Box, Card, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import 'modules/enps/pages/AnalyticsPage/index.styles.css'

import { useAnalytics } from 'modules/enps/pages/AnalyticsPage/useAnalytics'

const ParticipationNumber = () => {
  const { filteredResultsCount, answeredResultsCount } = useAnalytics()

  const participation = Math.round((answeredResultsCount * 100) / filteredResultsCount)

  return (
    <Card>
      <Card.Title>{i18n.t('enps.analytics.participation.title')}</Card.Title>
      <Card.Content>
        <Box width="full" height="full" gap="s24" justifyContent="center" alignItems="center">
          <Text.Header1 className={'AnalyticsPage_score'}>{participation + '%'}</Text.Header1>
          <Box alignSelf="flexStart" height="s32">
            <Text.Normal>
              <strong>{answeredResultsCount}</strong>{' '}
              {i18n.t('enps.analytics.participation.responses')}
            </Text.Normal>
            <Text.Normal>
              <strong>{filteredResultsCount}</strong>{' '}
              {i18n.t('enps.analytics.participation.employees')}
            </Text.Normal>
          </Box>
        </Box>
      </Card.Content>
    </Card>
  )
}
export default observer(ParticipationNumber)
